import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { ComponentUiDatastateComponent } from './component.ui.datastate/component.ui.datastate.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PagePlatformComponent } from './page.platform/page.platform.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageMypageComponent,
        LayoutEmptyComponent,
        ComponentUiDatastateComponent,
        LayoutSidebarComponent,
        PagePlatformComponent,
        PortalPostListComponent,
        PageMembersComponent,
        PageAccessComponent,
        PortalSeasonPaginationComponent,
        PortalSeasonFormDropdownComponent,
        PagePostsComponent,
        PortalSeasonLoadingDefaultComponent,
        PortalPostDetailComponent,
        PortalSeasonModalComponent,
        PortalSeasonTreeComponent,
        PageDashboardComponent,
        ComponentNavSidebarComponent,
        PagePostsItemComponent,
        PortalSeasonLoadingSeasonComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }